import React, { useEffect, useState } from "react";
import { authFetch, C } from "./App";

export function DashboardView({ token }) {
  const [stats, setStats] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    Promise.all([
      authFetch("/admin/incidents?status=pending", token).catch(() => ({ incidents: [] })),
      authFetch("/admin/users", token).catch(() => ({ users: [] })),
    ])
      .then(([pending, users]) => {
        setStats({
          pendingIncidents: pending.incidents?.length || 0,
          totalUsers: users.users?.length || 0,
          staffUsers: (users.users || []).filter((u) => u.group_id).length,
        });
      })
      .catch((e) => setErr(e.message));
  }, [token]);

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "#111", margin: "0 0 4px" }}>Dashboard</h1>
      <p style={{ fontSize: 13, color: C.gray, margin: "0 0 24px" }}>Overview of platform activity</p>

      {err && <div style={{ color: C.danger, fontSize: 13, marginBottom: 16 }}>{err}</div>}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14 }}>
        <StatCard label="Pending Incidents" value={stats?.pendingIncidents ?? "—"} color={C.warn} icon="🛡️" />
        <StatCard label="Total Users" value={stats?.totalUsers ?? "—"} color={C.green} icon="👤" />
        <StatCard label="Staff Accounts" value={stats?.staffUsers ?? "—"} color={C.gold === "#FCD116" ? "#B8860B" : C.gold} icon="🔑" />
      </div>

      <div style={{ marginTop: 28, background: C.white, border: `1px solid ${C.border}`, borderRadius: 12, padding: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 10 }}>Quick actions</div>
        <div style={{ fontSize: 13, color: C.gray, lineHeight: 1.7 }}>
          Use the sidebar to moderate incoming incident reports, manage user accounts and permission groups, or review server error logs.
        </div>
      </div>
    </div>
  );
}

function StatCard({ label, value, color, icon }) {
  return (
    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 12, padding: "18px 20px" }}>
      <div style={{ fontSize: 20, marginBottom: 8 }}>{icon}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color }}>{value}</div>
      <div style={{ fontSize: 12, color: C.gray, marginTop: 2 }}>{label}</div>
    </div>
  );
}
